"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    sessionId: zod_1.z.string().uuid(),
    feedbackType: zod_1.z.union([zod_1.z.literal('like'), zod_1.z.literal('dislike')]),
    meta: zod_1.z
        .object({
        appName: zod_1.z.string().nullable().optional(),
        appVersion: zod_1.z.string().nullable().optional(),
    })
        .optional(),
});
exports.path = '/log-alma-chat-feedback';
//# sourceMappingURL=index.js.map